import { Outlet, ScrollRestoration } from 'react-router-dom'
import { SidebarInset, SidebarProvider } from '~/ui/sidebar'
import { SiteHeader } from './site-header'
import { AppSidebar } from './app-sidebar'

export const SidebarLayout = () => {
  return (
    <SidebarProvider>
      <div className="flex h-screen w-full">
        <AppSidebar />
        <div className="flex flex-1 flex-col overflow-hidden">
          <SiteHeader />
          <SidebarInset className="flex-1 overflow-auto pt-12">
            <Outlet />
            <ScrollRestoration />
          </SidebarInset>
        </div>
      </div>
    </SidebarProvider>
  )
}
